import api from '../config/axiosConfig';

export const EstadoPostulanteService = {
    getEstadoPostulacion: async (token) => {
        try {
            const response = await api.get('/ajustes/estadopostulacion',
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.estadoPostulacion;
        } catch (error) {
            console.error('Error en EstadoPostulanteService.getEstadoPostulacion:', error);
            throw error;
        }
    },
};
